import { render } from "./Panel.vue?vue&type=template&id=cebd147e"
import script from "./Panel.vue?vue&type=script&lang=js"
export * from "./Panel.vue?vue&type=script&lang=js"

import "./Panel.vue?vue&type=style&index=0&id=cebd147e&lang=scss"
script.render = render

export default script